import { render, staticRenderFns } from "./RegionGrid.vue?vue&type=template&id=621c8eb6&scoped=true"
import script from "./RegionGrid.vue?vue&type=script&lang=js"
export * from "./RegionGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621c8eb6",
  null
  
)

export default component.exports